import { useAuth } from "@vega-api/custom";
import { getCurrentPortalType } from "@vega-api/extended/auth/redirectUtils";
import { EmailTextButton } from "@vega-core/components/Buttons/EmailTextButton/EmailTextButton";
import { SecondaryButton } from "@vega-core/components/Buttons/SecondaryButton";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { ModalHeader } from "@vega-core/components/Modals/ModalHeader/ModalHeader";
import { VegaDialog } from "@vega-core/components/Modals/VegaDialog/VegaDialog";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";

type Props = {
  open: boolean;
  onClose: VoidFunction;
};

export const WarningModal = ({ open, onClose }: Props) => {
  const { logout } = useAuth();
  const {
    contacts,
    global: { companyName },
  } = usePublicConfig();

  return (
    <VegaDialog data-testid="warning-dialog" onClose={onClose} open={open}>
      <div className="space-y-4">
        <ModalHeader title={m.welcome_terms_warningTitle()} />
        <div className="flex flex-col text-text/secondary text-sm gap-2">
          <div className="text-sm font-normal">
            {m.welcome_terms_warningMessage()}
          </div>
          <div>
            <span>{m.welcome_terms_warningAssistance()} </span>
            <EmailTextButton
              className="rich-link text-text/interactive"
              email={contacts.helpEmail}
              label={m.welcome_contact_companyInvestorServices({
                companyName,
              })}
            />
          </div>
        </div>
        <div className="flex w-full justify-end gap-4">
          <SecondaryButton
            className="w-auto min-w-[52px]"
            dataTestId="cancel-button"
            onClick={onClose}
          >
            {m.btn_cancel()}
          </SecondaryButton>
          <ThemedButton
            className="min-w-[52px]"
            dataTestId="decline-button"
            onClick={() =>
              logout({
                isGlobal: true,
                savePath: false,
                source: getCurrentPortalType(),
              })
            }
            variant="destructive"
          >
            {m.btn_decline()}
          </ThemedButton>
        </div>
      </div>
    </VegaDialog>
  );
};
